import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms'
import { environmentRoute } from 'pages/NWPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms'

export const mediaPlatformsRoute = createRoute({
  getParentRoute: () => environmentRoute,
  path: StaticRouteParameter.MEDIA_PLATFORMS,
  loader: () => ({
    crumb: t('entity:publishing.mediaPlatform', { count: 2 }),
  }),
})

export const mediaPlatformsOverviewLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformsRoute,
  id: 'mediaPlatformsOverviewLayout',
  component: () => <Structure />,
})

type MediaPlatformsOverviewSearch = {
  query?: string
}

export const mediaPlatformsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformsOverviewLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
